import React from "react";

const DEFAULT_STYLE = {
  width: "100%",
  maxWidth: 960,
  marginBottom: -6
};

const DEFAULT_LARGE_STYLE = {
  marginTop: 50
};

const FULL_WIDTH_STYLE = {
  width: "100%"
};

const FULL_WIDTH_LARGE_STYLE = {};

class FilmMarquee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      films: [],
    };

    this.getStyles = this.getStyles.bind(this);
    this.fetchFilms = this.fetchFilms.bind(this);
    this.filterByTag = this.filterByTag.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  componentDidMount() {
    this.fetchFilms(); // Initial fetch
  }

  getStyles() {
    let { isLarge, tenant, muiTheme } = this.context;

    return {
      eventiveMarquee:  {
        overflow: "hidden", /* Hides the scrolled out content */
        position: "relative",
        width: "100%",/* Ensures the marquee takes full width of its container */
        height: 300,
        paddingTop: 20,
      },
      marqueeContent: {
        display: "flex", /* Aligns slides in a row */
        animation: "scrollMarquee 24s linear infinite", /* Adjust duration based on total content width 960 being max */
      },
      posterSlide: {
        flex: "0 0 auto", /* This ensures that each slide maintains its size */
        width: 200, /* Adjust as needed */
        height: 300, /* Adjust as needed */
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginRight: 10, /* Space between slides */
        transition: "transform 0.3s ease", /* Smooth transition for scaling */
      },
      filmInfo: {
        position: "relative",
        top: "75%",
        left: 0,
        width: "100%",
        textAlign: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)", // White background with 70% opacity
        display: "none"
      },
      filmName: {
        color: "black",
        padding: 10
      }
    };
  }

  fetchFilms() {
  
    const{ event_bucket, api_key, welcome_film_marquee_filter_tag, welcome_film_marquee_limit } = this.context.tenant;
    let tag = welcome_film_marquee_filter_tag || null;
    let limit = welcome_film_marquee_limit || 10;

    const yourApiEndpointURL = `https://api.eventive.org/event_buckets/${event_bucket}/films?api_key=${api_key}&limit=${limit}`;
    fetch(yourApiEndpointURL)
      .then((response) => this.handleResponse(response))
      .then((data) => {
        console.log('API Response Data:', data); // Log the API response data

        const filteredFilms = this.filterByTag(data.films, tag);
        this.setState({ films: filteredFilms.slice(0, limit) }, () => {
          // Call the function after setting state to ensure the component has rendered
          this.duplicateContentForLoop();
        });
      })
      .catch((error) => console.error('Error fetching films:', error));
  }

  filterByTag(items, tag) {
    if (!tag) return items;
    return items.filter((item) => item.tags && item.tags.some((t) => t.name === tag));
  }

  handleResponse(response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }

  duplicateContentForLoop() {
    const marqueeContent = document.querySelector(".marquee-content");
    const slides = Array.from(marqueeContent.children);
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      marqueeContent.appendChild(clone);
    });
  }

  render() {
    let styles = this.getStyles();
    const { films } = this.state;
    return (
      <div style={styles.eventiveMarquee}>
        <div className="marquee-content" style={styles.marqueeContent}>
          {films.map((film) => (
            <a key={film.id} href={`/films/${film.id}`} target="_self">
              <div className="poster-slide" key={film.id + "_poster"} style={Object.assign({ backgroundImage: `url('${film.poster_image}')` }, styles.posterSlide)}>
                <div style={styles.filmInfo}>
                  <div style={styles.filmName}>{film.name}</div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    );
  }
}

export default FilmMarquee;



// WEBPACK FOOTER //
// ./src/app/components/partials/film-marquee.jsx